import { FunctionComponent } from 'react'
import useStyles from './styles'
import { Icon } from '@conexasaude/iconography/icons'
import { useHistory } from 'react-router-dom'

import { useThemeGeneratorContext } from '@/theme/contexts/ThemeGeneratorContext'
import useWindowSize from '@/utils/useWindowSize'
import CustomLayout from '@/components/CustomLayout'
import { IConsultationDetailsResponseGroup } from '../../types'
import { useGroupConsultationContext } from '../../contexts/consultationGroupContext'
import { ConsultationGroupCard } from '../../components/ConsultationCardGroup'
import { convertStringIntoDateArray } from '@/utils/date'
import ResumeDoctorGroup from '../../components/ResumeDoctorGroup'
import { getTheme, Text } from '@conexasaude/conexa-hero'
import { Illustration } from '@/components/HideIllustrationsExternal'
import { RenderIf } from '@/components/RenderIf'

const ConfirmGroupConsultation: FunctionComponent<
  IConsultationDetailsResponseGroup
> = () => {
  const styles = useStyles()
  const { isMobile } = useWindowSize()
  const { push } = useHistory()
  const { embed } = useThemeGeneratorContext()
  const { groupConsultationData } = useGroupConsultationContext()
  const theme = getTheme()

  return (
    <CustomLayout>
      <RenderIf condition={embed.full && !isMobile}>
        <div css={styles.wrapperLink}>
          <Text variant="link" onClick={() => push('/')}>
            <Icon name="back" color={theme.colors.neutral[300]} size="medium" />
            Voltar para o início
          </Text>
        </div>
      </RenderIf>

      <div css={styles.wrapperConfirmed}>
        <Illustration name="medic-smiling" />
        <Text variant="headingXLarge">
          Consulta em grupo confirmada com sucesso!
        </Text>
      </div>

      <Text variant="headingSmall" css={styles.subtitle}>
        Resumo
      </Text>
      <div css={styles.containerCards}>
        <div css={styles.wrapperResumeCard}>
          <ResumeDoctorGroup
            professionalName={groupConsultationData?.professionalName}
            professionalSpecialty={groupConsultationData?.professionalSpecialty}
          />
        </div>

        <div css={styles.wrapperCard}>
          <ConsultationGroupCard
            bodyOnly
            noTag
            readOnly
            theme={groupConsultationData?.theme}
            professionalId={groupConsultationData?.professionalId}
            professionalName={groupConsultationData?.professionalName.toLowerCase()}
            specialty={groupConsultationData?.professionalSpecialty}
            participants={groupConsultationData?.numberParticipants}
            status={groupConsultationData?.status}
            id={groupConsultationData?.id}
            appointmentDate={convertStringIntoDateArray(
              groupConsultationData?.appointmentDate.toString(),
            )}
            patientConfirmation={groupConsultationData?.numberParticipants.toString()}
          />
        </div>
      </div>
      <RenderIf condition={isMobile}>
        <Text variant="link" css={styles.linkFooter} onClick={() => push('/')}>
          Voltar para o início
        </Text>
      </RenderIf>
    </CustomLayout>
  )
}

export default ConfirmGroupConsultation
